import React from 'react';
import { Tag } from '../../../../components/tag';
import { Event } from '../../../../stores/events';
import { getProvincesTags } from '../../../../utils/provinces_tag';
import style from './styles.module.scss';

const EventRegion: React.FC<{ record: Event }> = React.memo(({ record }) => {
    const provincesNames = getProvincesTags(record.eventProvinces || []);

    return (
        <div className={style.region_container}>
            {provincesNames?.map((ep) => (
                <Tag variant="greek-blue" key={ep}>
                    {ep}
                </Tag>
            ))}
        </div>
    );
});
EventRegion.displayName = 'EventRegion';

export default EventRegion;
